import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { LayoutSplashScreen } from "../_metronic/layout";
import AmusementGroup from "./pages/AmusementGroups/Index";
import { DashboardPage } from "./pages/DashboardPage";
import Users from "./pages/Users/Index";
import { UsersSite } from "./pages/UsersSite/Index";
import { Roles } from './pages/Roles/Index';
import { Contact } from './pages/Contact/Index';
import AmusementService from './pages/AmusementServices/Index';
import AmusementServiceDate from './pages/AmusementServiceDate/CreateEditAmusementServiceDate';

import AmusementServicePromoCategory from './pages/AmusementServicePromoCategory/Index';
import NewpromoCategory from './pages/AmusementServicePromoCategory/CreateEditAmusementServicePromoCategory';

import PromoCategoryCommision from './pages/PromoCategoryCommision/Index';
import NewpromoCategoryCommision from './pages/PromoCategoryCommision/CreateEditAmusementServicePromoCategoryCommision';

import PromoCategoryAgent from './pages/PromoCategoryAgent/Index';
// import { Booking } from './pages/Booking/Index';
import Orders from './pages/Orders/Index';
import { ViewOrderContents } from './pages/Orders/components/ViewOrderContents';
import { ViewNewBasketContents } from './pages/Basket/components/ViewNewBasketContents';
import { ViewCanceledOrderContents } from './pages/CanceledOrder/components/ViewCanceledOrderContents';

import { UserPayment } from './pages/UserPayment/Index';
// import { Refund } from './pages/Refund/Index';
import Testimonial from './pages/Testimonial/Index';
import Region from './pages/Regions/Index';
import Portal from './pages/Portal/Index';
import { SmsInfo } from './pages/SmsInfo/Index';
import AboutUs from './pages/Cms/AboutUs/Index';

import CreateEditAmusementService from './pages/AmusementServices/CreateOrEdit';
// import AmusementServiceOption from './pages/AmusementServiceOptions/Index';
import AmusementInactiveSessions from './pages/AmusementInactiveSessions/Index';
import CacheManager from './pages/AmusementServices/CacheManager';
import UserWithdrawals from "./pages/UserWithdrawals/Index";
import UserTransactions from "./pages/UserTransaction/Index";
import Basket from "./pages/Basket/Index";
import BasketItemPersons from "./pages/BasketItemPerson/Index";
import Agency from "./pages/Agency/Index";
import Account from "./pages/Account/Index";
import { Details } from "./pages/UserWithdrawals/Details";
import { Gallery } from "./pages/Gallery/Index";
import FilesList from "./pages/FilesService/Index";
import CanceledOrder from "./pages/CanceledOrder/Index";
import AgentList from "./pages/Agent/Index";
import ChangePassword from "./pages/_Components/ChangePassword";
import AgencyTransaction from "./pages/AgencyTransaction/Index";
import UsedCommissionByAgent from './pages/UsedPromoCodeByUser/Index';
import UsedCommissionByAgentReturn from './pages/UsedPromoCodeByUserReturn/Index';
import EditTransaction from "./pages/EditTransaction/Index";
import BasketReport from "./pages/BasketReport/Index";

import PrivatePromoCodeList from './pages/PromoCode/Index';
import ReportTransaction from './pages/Reports/ReportTransaction/Index';
import ReportSellBuy from './pages/Reports/ReportSellBuy/Index';
import AmusementServiceReserveItem from './pages/AmusementServiceReserveItem/Index';
import AmusementServiceReserveItemGroup from './pages/AmusementServiceReserveItemGroup/Index';
import AmusementServiceReservationForm from './pages/AmusementServiceReservationForm';
import AmusementComplex from './pages/AmusementComplex/Index';
import CreateEditAmusementComplex from './pages/AmusementComplex/CreateOrEdit';
import AmusementDescription from './pages/AmusementDescription/Index';
import SupplierTransactions from "./pages/SupplierTransactions/Index";
import SupplierList from "./pages/Supplier/Index";
import PageContent from "./pages/PageContent/Index"
import SinglePageContent from "./pages/PageContent/EditAddPageContent"
import AmusementPackage from "./pages/AmusementPackage/Index"
import AddEditPackageItems from "./pages/AmusementPackage/AddEditPackageItems"
import ReportSell from './pages/Reports/ReportSell/Index';
import AgentCommission from "./pages/AgentCommission/Index";
import EditAgentCommissionItems from "./pages/AgentCommission/EditAgentCommissionItems";
import SupplierAgentCommission from "./pages/SupplierAgentCommission/Index";

const PublicPromoCodeList = lazy(() => import("./pages/PublicPromoCode/Index"))
const SellCharts = lazy(() => import("./pages/Reports/SellChart"))
const Hall = lazy(() => import("./pages/Halls"))
const LockedSeats = lazy(() => import("./pages/LockedSeats"))
const CreateOrEditHallPrice = lazy(() => import("./pages/HallPricings/CreateOrEditPrice"))
const CreateOrEditHallEvent = lazy(() => import("./pages/HallEvents/CreateOrEditPrice"))
const CreateOrEdit = lazy(() => import("./pages/Halls/CreateOrEdit"))
const HallEvents = lazy(() => import("./pages/HallEvents"))
const HallPricings = lazy(() => import("./pages/HallPricings"))
const AmusementServicePromoCategoryEvent = lazy(() => import("./pages/AmusementServicePromoCategory/EventPromoCode"))
const SupplierCommissionEvent = lazy(() => import("./pages/AgentCommission/EventSupllierCommission"))
const AmusementServicePromoCategoryCommissionEvent = lazy(() => import("./pages/PromoCategoryCommision/EventCategoryCommission"))
const ReservationFormCalendar = lazy(() => import("./pages/ReservationFormCalendar"))
const ReservationCapacityManagement = lazy(() => import("./pages/ReservationCapacityManagement"))
const AmusementServiceReserveItemTicketSources = lazy(() => import("./pages/AmusementServiceReserveItemTicketSources"))
const ReservationFormExpirationReport = lazy(() => import("./pages/ReservationFormExpirationReport"))

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      {/* <Router> */}
      <Routes>
        {/* Redirect from root URL to /dashboard. */}
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/reservationFormCalendar" element={<ReservationFormCalendar />} />
        <Route path="/reservationCapacityManagement" element={<ReservationCapacityManagement />} />

        <Route path="/changepassword" element={<ChangePassword />} />
        <Route path="/amusementGroups" element={<AmusementGroup />} />
        <Route path="/amusementService" element={<AmusementService />} />
        <Route path="/amusementServiceDate" element={<AmusementServiceDate />} />
        <Route path="/promoCategory" element={<AmusementServicePromoCategory />} />
        <Route path="/CreateEditAmusementServicePromoCategory/:id" element={<NewpromoCategory />} />
        <Route path="/EventAmusementServicePromoCommissionCategory/:id" element={<AmusementServicePromoCategoryCommissionEvent />} />
        <Route path="/eventAmusementServicePromoCategory/:id" element={<AmusementServicePromoCategoryEvent />} />
        <Route path="/supplierCommissionEvent/:id" element={<SupplierCommissionEvent />} />
        <Route path="/createOrEditService/:id" element={<CreateEditAmusementService />} />
        {/* <Route path="/amusementServiceOption" element={<AmusementServiceOption />} /> */}
        <Route path="/AmusementInactiveSessions" element={<AmusementInactiveSessions />} />
        <Route path="/cacheManager" element={<CacheManager />} />
        <Route path="/users" element={<Users />} />
        <Route path="/usersSite" element={<UsersSite />} />
        <Route path="/contact" element={<Contact />} />
        {/* <Route path="/booingPayment" element={<Booking />} /> */}
        <Route path="/ordersList" element={<Orders />} />
        <Route path="/viewNewBasketContents/:id" element={<ViewNewBasketContents />} />
        <Route path="/viewOrderContents/:id" element={<ViewOrderContents />} />
        <Route path="/ViewCanceledOrderContents/:id" element={<ViewCanceledOrderContents />} />
        <Route path="/userPayment" element={<UserPayment />} />
        {/* <Route path="/returnOrder" element={<Refund />} /> */}
        <Route path="/testimonials" element={<Testimonial />} />
        <Route path="/regions" element={<Region />} />
        <Route path="/portals" element={<Portal />} />
        <Route path="/roles" element={<Roles />} />
        <Route path="/smsInfo" element={<SmsInfo />} />
        <Route path="/userWithdrawalsDetails/:id" element={<Details />} />
        <Route path="/userWithdrawals" element={<UserWithdrawals />} />
        <Route path="/userTransactions" element={<UserTransactions />} />
        <Route path="/basket" element={<Basket />} />
        <Route path="/basketItemPerson" element={<BasketItemPersons />} />
        <Route path="/agencies" element={<Agency />} />
        <Route path="/accounts" element={<Account />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/galleris" element={<Gallery />} />
        <Route path="/files" element={<FilesList />} />
        <Route path="/canceled" element={<CanceledOrder />} />
        <Route path="/agencytransaction" element={<AgencyTransaction />} />
        <Route path="/editTransaction" element={<EditTransaction />} />
        <Route path="/basketReport" element={<BasketReport />} />
        <Route path="/agentList" element={<AgentList />} />
        <Route path="/promoCategoryCommision" element={<PromoCategoryCommision />} />
        <Route path="/CreateEditAmusementServicePromoCategoryCommision/:id" element={<NewpromoCategoryCommision />} />
        <Route path="/promoCategoryAgent" element={<PromoCategoryAgent />} />
        <Route path="/usedCommissionByAgent" element={<UsedCommissionByAgent />} />
        <Route path="/usedCommissionByAgentReturn" element={<UsedCommissionByAgentReturn />} />
        <Route path="/privatePromoCodeList" element={<PrivatePromoCodeList />} />
        <Route path="/publicPromoCode" element={<PublicPromoCodeList />} />
        <Route path="/reportTransaction" element={<ReportTransaction />} />
        <Route path="/reportSellTransaction" element={<ReportSellBuy />} />
        <Route path="/reportBuyTransaction" element={<ReportSellBuy />} />
        <Route path="/AmusementServiceReserveItem" element={<AmusementServiceReserveItem />} />
        <Route path="/AmusementServiceReserveItemGroup" element={<AmusementServiceReserveItemGroup />} />
        <Route path="/ReservationForm" element={<AmusementServiceReservationForm />} />
        <Route path="/amusementComplex" element={<AmusementComplex />} />
        <Route path="/createEditAmusementComplex/:id" element={<CreateEditAmusementComplex />} />
        <Route path="/amusementDescription" element={<AmusementDescription />} />
        <Route path="/reservationFormDescription" element={<AmusementDescription />} />
        <Route path="/supplierTransactions" element={<SupplierTransactions />} />
        <Route path="/pageContent" element={<PageContent />} />
        <Route path="/pageContent/:id" element={<SinglePageContent />} />
        <Route path="/amusementPackage" element={<AmusementPackage />} />
        <Route path="/amusementPackage/:id" element={<AddEditPackageItems />} />
        <Route path="/reportSell" element={<ReportSell />} />
        <Route path="/sellCharts" element={<SellCharts />} />
        {/* Hall Pages */}
        <Route path="/halls" element={<Hall />} />
        <Route path="/lockedSeats" element={<LockedSeats />} />
        <Route path="/halls/:id" element={<CreateOrEdit />} />
        <Route path="/hallPricings/:id" element={<CreateOrEditHallPrice />} />
        <Route path="/hallEvents/:id" element={<CreateOrEditHallEvent />} />
        <Route path="/hallEvents" element={<HallEvents />} />
        <Route path="/hallPricings" element={<HallPricings />} />

        {/* AmusementService ReserveItemTickets */}
        <Route path="/amusementServiceReserveItemTicketSources" element={<AmusementServiceReserveItemTicketSources />} />

        {/* ReservationFormExpirationReport */}
        <Route path="/reservationFormExpirationReport" element={<ReservationFormExpirationReport />} />
        <Route path="/reservationFormExpirationReport" element={<ReservationFormExpirationReport />} />

        {/* <Route path="/amusementGroups/createOrEditAmusementGroup" element={<CreateOrEditAmusementGroup />} /> */}
        <Route path="/supplierList" element={<SupplierList />} />
        <Route path="/agentCommissions" element={<AgentCommission />} />
        <Route path="/editAgentCommissionItems/:id" element={<EditAgentCommissionItems />} />
        <Route path="/supplierAgentCommissions" element={<SupplierAgentCommission />} />
        <Route path="*" element={<Navigate to="error/error-v1" />} />
      </Routes>
      {/* </Router> */}
    </Suspense>
  );
}
